namespace Solovis.Reports.DataSetHelpers {


    /**
     * TagBreakoutHelper helps manage tracking the set of tag branches that have been seen and whether
     * specific tags have been seen or just their leaf nodes.
     */
    export class TagBreakoutHelper {

        public tagSet;
        public _tagIdToGroupMap;
        
        constructor(options) {
            if (options.tagSet) {
                this.tagSet = options.tagSet;
            }
            else {
                var modelEnv = options.modelEnvironment ? options.modelEnvironment : null;
                var tagSetId = options.tagSetId ? options.tagSetId : null;

                if (modelEnv && tagSetId) {
                    this.tagSet = modelEnv.tagSets.tryGetById(tagSetId);
                }
            }

            if (!this.tagSet) {
                throw "tagSet could not be found";
            }

            // _tagIdToGroupMap will provide hierarchical grouping of tags that are represented.            
            this._tagIdToGroupMap = {}
        }

        public reportTagIdInUse(tagId) {
            var tagGroup = this.getOrCreateTagGroup(tagId);
            if (tagGroup) {
                tagGroup.hasValue = true;
            }

            return tagGroup;
        }

        public getOrCreateTagGroup(tagId) {
            var tagGroup = null;

            if (tagId) {
                if (this._tagIdToGroupMap[tagId]) {
                    tagGroup = this._tagIdToGroupMap[tagId];
                }
                else if (this.tagSet) {
                    var tag = this.tagSet.tryGetTagById(tagId);
                    if (tag) {
                        tagGroup = {
                            tag: tag,
                        };

                        if (tag.parentTagId) {
                            tagGroup.parentGroup = this.getOrCreateTagGroup(tag.parentTagId);
                        }

                        this._tagIdToGroupMap[tagId] = tagGroup;
                    }
                }
            }
            else {
                var unknownTagId = -1;
                if (this._tagIdToGroupMap[unknownTagId]) {
                    tagGroup = this._tagIdToGroupMap[unknownTagId];
                }
                else {
                    tagGroup = {
                        tag: null,
                        isUnknown: true
                    };

                    this._tagIdToGroupMap[unknownTagId] = tagGroup;
                }
            }

            return tagGroup;
        }

        public getBreakoutCategories() {
            /// <summary> 
            /// getBreakoutCategories returns a list of categories with labels and tag id that should be used for source data.
            /// This is useful for generating a list of ordered categories that can be incorporated into a data table as columns or rows.
            /// </summary>

            var self = this;
            var categories = this._getDirectChildCategoriesForTagId(null);

            var expandedCategories = [];
            $(categories).each(function (i, category) {
                var expandedCategory = self._expandBreakoutCategory(category);
                expandedCategories = expandedCategories.concat(expandedCategory);
            });

            var maxLevelDepth = 0;
            $(expandedCategories).each(function (i, category) {
                var level = self._getLevelDepthForCategoryTag(category);
                if (level > maxLevelDepth) {
                    maxLevelDepth = level;
                }
            });

            $(expandedCategories).each(function (i, category: any) {
                category.superHeaders = self._getSuperHeadersForCategory(category, maxLevelDepth);
            });

            return expandedCategories;
        }

        public _expandBreakoutCategory(category) {
            if (category.isBranchOtherGroup) {
                // Case where we created a sub-category on the fly for a parent tag that has children but also values for itself that are not more specific.
                return [category];
            }
            if (category.isUnknown) {
                return [category];
            }

            var self = this;

            var subCategories = this._getDirectChildCategoriesForTagId(category.tagId);

            if (!subCategories || subCategories.length == 0) {
                return [category];
            }
            else {
                var expandedSubCategories = [];
                $(subCategories).each(function (i, subCategory) {
                    var expandedSubCategory = self._expandBreakoutCategory(subCategory);
                    expandedSubCategories = expandedSubCategories.concat(expandedSubCategory);
                });
                return expandedSubCategories;
            }
        }

        public _getDirectChildCategoriesForTagId(tagId) {
            var self = this;

            var categories = [];

            if (tagId) {
                if (this._tagIdToGroupMap[tagId]) {
                    var tagGroup = this._tagIdToGroupMap[tagId];
                    var tag = tagGroup.tag;

                    if (tag.childTags) {
                        $(tag.childTags).each(function (i, childTag: any) {
                            if (self._tagIdToGroupMap[childTag.id]) {
                                var childTagGroup = self._tagIdToGroupMap[childTag.id];

                                categories.push({
                                    label: childTag.label,
                                    tagId: childTag.id,
                                    tagGroup: childTagGroup
                                });
                            }
                        });
                    }

                    if (tagGroup.hasValue && categories.length > 0) {
                        // We will add another group for the tag value "Other" values.
                        categories.push({
                            label: tag.label + " (Other)",
                            tagId: tag.id,
                            tagGroup: tagGroup,
                            isBranchOtherGroup: true
                        });
                    }
                }
            }
            else {
                if (this.tagSet && this.tagSet.rootTags) {
                    $(this.tagSet.rootTags).each(function (i, rootTag: any) {
                        if (self._tagIdToGroupMap[rootTag.id]) {
                            var rootTagGroup = self._tagIdToGroupMap[rootTag.id];

                            categories.push({
                                label: rootTag.label,
                                tagId: rootTag.id,
                                tagGroup: rootTagGroup
                            });
                        }
                    });

                    if (this._tagIdToGroupMap[-1]) {
                        // Pull in unknown tag category group.
                        categories.push({
                            label: "Unknown",
                            tagId: null,
                            isUnknown: true,
                            tagGroup: this._tagIdToGroupMap[-1]
                        });
                    }
                }
            }

            // Sort categories by label.
            categories.sort(function (a, b) {
                // (Other) group should always go at end.
                if (!a.isBranchOtherGroup && b.isBranchOtherGroup) {
                    return -1;
                }
                else if (a.isBranchOtherGroup && !b.isBranchOtherGroup) {
                    return 1;
                }

                // Otherwise, sort by case.
                var aLabelLower = a.label.toLowerCase();
                var bLabelLower = b.label.toLowerCase();

                if (aLabelLower < bLabelLower) {
                    return -1;
                }
                else if (aLabelLower > bLabelLower) {
                    return 1;
                }
                else {
                    return 0;
                }
            });

            return categories;
        }


        public _getLevelDepthForCategoryTag(category) {
            var tagId = category.tagId;
            var superHeaders = null;

            if (tagId) {
                var tag = this.tagSet.tryGetTagById(tagId);
                if (tag) {
                    if (!category.isBranchOtherGroup) {
                        return tag.level;
                    }
                    else {
                        return tag.level + 1;
                    }
                }
            }

            return 0;
        }

        public _getSuperHeadersForCategory(category, superHeaderLevels) {
            var tagId = category.tagId;
            var superHeaders = null;

            if (tagId) {
                var tag = this.tagSet.tryGetTagById(tagId);
                if (tag) {
                    var level = tag.level;
                    if (!category.isBranchOtherGroup) {
                        level--;
                    }

                    var blankLevelsToAdd = superHeaderLevels - level - 1;
                    if (tag.level == 0 && level == -1 && superHeaderLevels > 0) {
                        // We will repeat the root level tag at the top level of super headers to maintain balance.
                        blankLevelsToAdd--;
                    }

                    while (blankLevelsToAdd > 0) {
                        if (!superHeaders) {
                            superHeaders = [];
                        }

                        superHeaders.push("");
                        blankLevelsToAdd--;
                    }

                    if (tag.level == 0 && level == -1 && superHeaderLevels > 0) {
                        // In this special case, we will repeat the tag label as a super header to maintain balance.
                        if (!superHeaders) {
                            superHeaders = [];
                        }

                        superHeaders.push(tag.label);
                    }

                    while (level >= 0) {
                        var levelLabel = tag.getLevelLabel(level);

                        if (!superHeaders) {
                            superHeaders = [];
                        }

                        superHeaders.push(levelLabel);

                        level--;
                    }
                }
            }

            return superHeaders;
        }
    }

}
